module.exports = __webpack_public_path__ + "img/category-1.5f78d6cf.svg";